import reducer from './clients.reducer';
import * as action from './clients.action';
import * as selector from './clients.selector';
import * as constant from './clients.constant';
import initialState from './clients.initialState';
import saga from './clients.saga';

export default {
  reducer,
  action,
  constant,
  selector,
  initialState,
  saga,
  name: constant.NAME,
};
